import { SvgProps } from "components/icons/types";

export const ShoppingCartIcon = ({
  width = 16,
  height = 16,
  ...props
}: SvgProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 1.75H2.4745L2.45 1.54525C2.39986 1.11966 2.19531 0.72726 1.87512 0.442445C1.55493 0.15763 1.14137 0.00019938 0.712833 0L0 0V1.16667H0.712833C0.855711 1.16669 0.993613 1.21914 1.10038 1.31408C1.20715 1.40903 1.27537 1.53985 1.29208 1.68175L2.21667 9.53808C2.2668 9.96367 2.47136 10.3561 2.79155 10.6409C3.11174 10.9257 3.5253 11.0831 3.95383 11.0833H11.6667V9.91667H3.95383C3.81087 9.91663 3.67289 9.86409 3.56611 9.76903C3.45932 9.67397 3.39117 9.543 3.37458 9.401L3.29817 8.75H12.7377L14 1.75ZM11.7623 7.58333H3.16108L2.61217 2.91667H12.6041L11.7623 7.58333Z"
      fill="currentColor"
    />
    <path
      d="M4.08342 14.0004C4.72775 14.0004 5.25008 13.478 5.25008 12.8337C5.25008 12.1894 4.72775 11.667 4.08342 11.667C3.43909 11.667 2.91676 12.1894 2.91676 12.8337C2.91676 13.478 3.43909 14.0004 4.08342 14.0004Z"
      fill="currentColor"
    />
    <path
      d="M9.91666 14.0004C10.561 14.0004 11.0833 13.478 11.0833 12.8337C11.0833 12.1894 10.561 11.667 9.91666 11.667C9.27233 11.667 8.75 12.1894 8.75 12.8337C8.75 13.478 9.27233 14.0004 9.91666 14.0004Z"
      fill="currentColor"
    />
  </svg>
);
